import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Calendar, Clock, BookOpen, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { blogs } from '../data/mock';

const Blogs = () => {
  const [visibleBlogs, setVisibleBlogs] = useState(3);
  
  const loadMore = () => {
    setVisibleBlogs(prev => Math.min(prev + 3, blogs.length));
  };

  return (
    <section id="blogs" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-amber-600 font-semibold text-lg mb-2">Insights & Updates</p>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-800 mb-4">
            Latest Articles
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Stay updated with the latest developments in taxation, compliance, and regulatory matters
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogs.slice(0, visibleBlogs).map((blog) => (
            <Card
              key={blog.id}
              className="group hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-none overflow-hidden"
            >
              <div className="overflow-hidden">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-300"
                />
              </div>
              <CardHeader>
                <div className="flex items-center gap-3 mb-3">
                  <Badge className="bg-amber-100 text-amber-700 hover:bg-amber-200">
                    {blog.category}
                  </Badge>
                  <div className="flex items-center text-sm text-gray-500">
                    <Clock className="w-4 h-4 mr-1" />
                    {blog.readTime}
                  </div>
                </div>
                <CardTitle className="text-xl font-bold text-slate-800 group-hover:text-amber-600 transition-colors line-clamp-2">
                  {blog.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600 leading-relaxed mb-4 line-clamp-3">
                  {blog.excerpt}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <div className="flex items-center text-sm text-gray-500">
                    <Calendar className="w-4 h-4 mr-2" />
                    {new Date(blog.date).toLocaleDateString('en-US', { 
                      month: 'short', 
                      day: 'numeric', 
                      year: 'numeric' 
                    })}
                  </div>
                  <button className="text-amber-600 hover:text-amber-700 font-semibold flex items-center group">
                    Read More
                    <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                  </button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {visibleBlogs < blogs.length && (
          <div className="text-center mt-12">
            <Button
              onClick={loadMore}
              size="lg"
              className="bg-amber-600 hover:bg-amber-700 text-white px-8"
            >
              <BookOpen className="w-5 h-5 mr-2" />
              Load More Articles
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Blogs;